import PointCloudViewer from "./PointCloudViewer";

export default PointCloudViewer;
